import React, { useState } from 'react';
import Logo from '../Logo';

const Header = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    return (
        <>
            <header className="bg-white border-b border-gray-100 relative z-50">
                <div className="w-full px-4 py-4 flex items-center justify-between">
                    <div className="ml-4">
                        <Logo width="208" height="32" textFill="black" />
                    </div>
                    <div className="hidden md:flex items-center gap-8 mr-4">
                        <a 
                            href="mailto:info@rocketlabventures.com" 
                            className="text-gray-700 text-sm font-medium hover:text-blue-600 transition-colors"
                        >
                            Contact
                        </a>
                        <a href="mailto:info@rocketlabventures.com">
                            <div className="px-6 py-2.5 bg-blue-600 rounded !text-stone-100 text-sm font-bold hover:bg-blue-700 transition-colors">
                                Get in Touch
                            </div>
                        </a>
                    </div>
                    <button 
                        onClick={() => setMobileMenuOpen(true)}
                        className="md:hidden text-gray-700 hover:text-blue-600 mr-4"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    </button>
                </div>
            </header>

            {mobileMenuOpen && (
                <div className="fixed inset-0 bg-white z-50 md:hidden">
                    <div className="flex flex-col h-full">
                        <div className="flex items-center justify-between p-4 border-b border-gray-100">
                            <Logo width="208" height="32" textFill="black" />
                            <button 
                                onClick={() => setMobileMenuOpen(false)}
                                className="text-gray-700 hover:text-blue-600"
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <div className="flex flex-col items-center justify-center flex-1 gap-8 p-8">
                            <a 
                                href="mailto:info@rocketlabventures.com"
                                onClick={() => setMobileMenuOpen(false)}
                                className="text-gray-700 text-2xl font-medium hover:text-blue-600 transition-colors"
                            >
                                Contact
                            </a>
                            <a href="mailto:info@rocketlabventures.com" onClick={() => setMobileMenuOpen(false)}>
                                <div className="px-8 py-4 bg-blue-600 rounded text-white text-xl font-bold hover:bg-blue-700 transition-colors">
                                    Get in Touch
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Header;